import React, { useContext, useState } from 'react'
import { PIMCORE_URL, ENDPOINTS, ESW_CLASSNAMES, BASE_COUNTRY_ISO } from '../../constants'
import AppContext from '../context/app'
import Button from 'react-bootstrap/Button'
import Spinner from 'react-bootstrap/Spinner'
import classNames from 'classnames'
import Form from 'react-bootstrap/Form'
import InputGroup from 'react-bootstrap/InputGroup'
import { ReactComponent as CheckCircleOutline } from '../images/check-circle-outline.svg'
import { ReactComponent as CheckCircleFilled } from '../images/check-circle-filled.svg'
import { useTheme } from '@emotion/react'

export default function PromoCode() {
    const theme = useTheme()
    const { cartId, cart, country } = useContext(AppContext)
    const { voucher_code, total_discount } = cart
    const [input, setInput] = useState(voucher_code ?? '')
    const [validating, setValidating] = useState(false)

    const handleSubmit = async (e) => {
        e.preventDefault()

        setValidating(true)
        const iso = country?.countryIso
        const url = `${PIMCORE_URL}${ENDPOINTS.REDEEM_VOUCHER(iso)}`
        const options = {
            method: 'post',
            body: JSON.stringify({
                session_cart_id: cartId,
                voucher_code: input,
            })
        }

        const r = await fetch(url, options)
        const { success, message } = await r.json()
        setValidating(false)
        
        if (success) {
            if (typeof window === 'undefined') return
            const event = new Event('CART_CHANGE')
            window.dispatchEvent(event)
        } else {
            console.error(message)
        }
    }

    const handleRollback = async () => {
        setValidating(true)
        const iso = country?.countryIso
        const url = `${PIMCORE_URL}${ENDPOINTS.ROLLBACK_VOUCHER(iso)}`
        const options = {
            method: 'post',
            body: JSON.stringify({
                session_cart_id: cartId,
            })
        }

        const r = await fetch(url, options)
        const { success, message } = await r.json()
        setValidating(false)

        if (success) {
            setInput('')
            if (typeof window === 'undefined') return
            const event = new Event('CART_CHANGE')
            window.dispatchEvent(event)
        } else {
            console.error(message)
        }
    }

    return (
        <form
            onSubmit={handleSubmit}
            className='d-flex align-items-center gap-4 my-4'
        >
            <InputGroup>
                <InputGroup.Text
                    className='bg-transparent border-0 p-0'
                    style={{ fontSize: 14 }}
                >
                    Got a promo code?
                </InputGroup.Text>
                <Form.Control
                    value={input}
                    name='promo-code'
                    autoComplete='off'
                    onChange={(e) => setInput(e.target.value.toUpperCase())}
                    disabled={Boolean(voucher_code)}
                    className='oswald'
                    style={{ marginLeft: 16, flex: '0 1 300px' }}
                    placeholder='ENTER PROMO CODE'
                    css={{'& ::placeholder': { color: theme.colors.secondary }}}
                />
                <Button
                    type='submit'
                    className='d-flex align-items-center gap-1 border'
                    variant={input ? 'dark' : 'secondary'}
                    disabled={voucher_code || !input}
                    css={{'& path': { fill: 'white' }}}
                >
                    {
                        validating ?
                            <Spinner role="status" size='sm'><span className="visually-hidden">Loading...</span></Spinner> :
                            voucher_code ? <><CheckCircleFilled/>APPLIED</> : <><CheckCircleOutline/>VALIDATE</>
                    }
                </Button>
                {voucher_code && (<>
                    <span className='my-auto' style={{ marginLeft: 16 }}>-</span>
                    <InputGroup.Text
                        data-bp-lti={'€' + total_discount}
                        style={{ fontSize: 14 }}
                        className={classNames(
                            ESW_CLASSNAMES.PAGE_PRICE,
                            'bg-transparent border-0 p-0 fw-bold'
                        )}
                    >
                        {`${country?.currencySymbol}${total_discount}`}
                    </InputGroup.Text>
                    <Button
                        variant=''
                        onClick={handleRollback}
                        className='d-flex align-items-center p-0'
                        style={{ marginLeft: 8 }}
                    >
                        <img src='/svg/cancel-icon-black.svg' alt='' />
                    </Button>
                </>)}
            </InputGroup>
        </form>
    )
}